export default __webpack_public_path__ + "static/media/water1.ee9538c6.png";